import { Button, message } from 'antd';
import React from 'react';

import { deleteOutsourcedVendor } from '../../helpers/api';

const DeleteVendor: React.FC<{
  vendorId: string;
  updateVendors: () => void;
}> = ({ vendorId, updateVendors }) => {
  const handleDelete = async () => {
    try {
      await deleteOutsourcedVendor(vendorId);
      message.success('刪除成功');
      updateVendors();
    } catch (error) {
      console.error(error);
      message.error('刪除失敗');
    }
  };

  return (
    <Button type="primary" danger onClick={handleDelete}>
      刪除
    </Button>
  );
};

export default DeleteVendor;
